import { useNavigate } from "react-router-dom";
import { User, ChevronRight } from "lucide-react";
import type { FollowUserDto } from "@tabipla/shared";
import { FollowButton } from "./FollowButton";

interface FollowListItemProps {
  user: FollowUserDto;
}

export function FollowListItem({ user }: FollowListItemProps) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/users/${user.id}`);
  };

  // Render avatar based on user settings
  const renderAvatar = () => {
    if (user.image) {
      return <img src={user.image} alt={user.name} className="h-full w-full object-cover" />;
    }
    if (user.avatarEmoji && user.avatarColor) {
      return (
        <div
          className={`flex h-full w-full items-center justify-center bg-gradient-to-br ${user.avatarColor} text-xl`}
        >
          {user.avatarEmoji}
        </div>
      );
    }
    return <User className="h-6 w-6 text-primary" />;
  };

  return (
    <div className="flex items-center gap-3 border-b p-4 last:border-b-0">
      {/* User info - clickable area */}
      <button
        onClick={handleClick}
        className="group flex min-w-0 flex-1 items-center gap-3 rounded-xl border border-transparent bg-muted/30 p-3 transition-all hover:border-primary/30 hover:bg-primary/10 hover:shadow-sm active:scale-[0.98]"
      >
        {/* Avatar */}
        <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary/10 ring-2 ring-primary/30 transition-all group-hover:ring-primary">
          {renderAvatar()}
        </div>

        {/* Name */}
        <div className="min-w-0 flex-1 text-left">
          <p className="truncate font-semibold transition-colors group-hover:text-primary">
            {user.name}
          </p>
          <p className="text-sm text-muted-foreground">プロフィールを見る</p>
        </div>

        {/* Chevron indicator */}
        <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground transition-all group-hover:translate-x-1 group-hover:text-primary" />
      </button>

      {/* Follow button - separate click area */}
      <div className="shrink-0">
        <FollowButton userId={user.id} isFollowing={user.isFollowing} size="sm" />
      </div>
    </div>
  );
}
